module.exports = __webpack_public_path__ + "img/269-68d9b1.png";